import { useMemo } from "react";

import type { CommentCountNodeArgs } from "@framework/comments/comments.types";
import { getCommentCountId } from "@framework/comments/get-comment-count-id";
import { useIsCycloneCommentsProvider } from "@voxmedia/duet-context/context/use-comment-counts-context";

/** Resolves the comment count store key for the mounted comment provider. */
export function useCommentCountId(args: CommentCountNodeArgs): string {
  const isCyclone = useIsCycloneCommentsProvider();

  return useMemo(
    () => getCommentCountId(args, isCyclone ? "cyclone" : "coral"),
    [isCyclone, args],
  );
}
